import { Injectable } from "@angular/core";
import { ApiDataService } from "@services/http/ApiDataService";
import { Observable, of } from "rxjs";
import { isGuid } from "@methods/uniqueMethods";
import { ModuleType } from "@enums/ModuleType";
import { ControlDetailOverviewModel } from "./ControlDetailOverviewModel";

@Injectable()
export class ControlDetailOverviewDataService extends ApiDataService {
    constructor() {
        super("controls");
    }

    public getControlOverview(guid: string): Observable<ControlDetailOverviewModel> {
        if (!isGuid(guid)) {
            return of(new ControlDetailOverviewModel());
        }

        const url = `/${guid}/overview`;
        return this.get<ControlDetailOverviewModel>(url);
    }

    public getCompletedTestControlOverview(
        controlGuid: string,
        effectivenessGuid: string
    ): Observable<ControlDetailOverviewModel> {
        if (!isGuid(controlGuid) || !isGuid(effectivenessGuid)) {
            return of(new ControlDetailOverviewModel());
        }

        const url = `/${controlGuid}/completedtestoverview/${effectivenessGuid}`;
        return this.get<ControlDetailOverviewModel>(url);
    }

    public getControlOverviewWithModule(
        guid: string,
        parentModule: ModuleType,
        parentGuid: string
    ): Observable<ControlDetailOverviewModel> {
        if (!isGuid(guid)) {
            return of(new ControlDetailOverviewModel());
        }

        const url = `/${guid}/overview/${parentModule}/${parentGuid}`;
        return this.get<ControlDetailOverviewModel>(url);
    }
}
